import { render, staticRenderFns } from "./versionSelectBox.vue?vue&type=template&id=6c5ef9b2&scoped=true&"
import script from "./versionSelectBox.vue?vue&type=script&lang=js&"
export * from "./versionSelectBox.vue?vue&type=script&lang=js&"
import style0 from "./versionSelectBox.vue?vue&type=style&index=0&id=6c5ef9b2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5ef9b2",
  null
  
)

export default component.exports